import React from 'react';
import { useTranslation } from '../utils/translations/TranslationProvider';

interface TextProps {
  translationKey?: string;
  fallback?: string;
  as?: 'span' | 'p' | 'h1' | 'h2' | 'h3' | 'h4' | 'h5' | 'h6' | 'div';
  className?: string;
  children?: React.ReactNode;
  [key: string]: any;
}

export const Text: React.FC<TextProps> = ({
  translationKey,
  fallback,
  as: Component = 'span',
  className = '',
  children,
  ...props
}) => {
  const { t } = useTranslation();
  if (children)
    return <Component className={className} {...props}>{children}</Component>;
  if (translationKey)
    return <Component className={className} {...props}>{t(translationKey, fallback)}</Component>;
  return <Component className={className} {...props} />;
};

export default Text;
